/**
 * Build query params for partner team-seat assignee filters (trips, bookings, pipeline).
 */
export function buildAssigneeFilterParams(teamMemberFilter) {
  const params = new URLSearchParams();
  if (teamMemberFilter === 'mine') {
    params.set('assignedFilter', 'mine');
  } else if (teamMemberFilter === 'anyone') {
    params.set('assignedFilter', 'anyone');
  } else if (teamMemberFilter && teamMemberFilter !== 'all') {
    params.set('assignedPartnerUserId', teamMemberFilter);
  }
  return params;
}
